var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDislike(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#FCE9EB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7947 13.4637H12.448L12.9798 15.8344C13.0587 16.1273 13.0015 16.4402 12.824 16.6861C12.6465 16.9321 12.3676 17.0851 12.0647 17.1025C11.7424 17.0979 11.4457 16.9256 11.282 16.6478L9.32248 13.4637H8.75904C8.63626 13.4637 8.5185 13.415 8.43171 13.3282C8.34492 13.2413 8.29614 13.1236 8.29614 13.0007V7.36067C8.29614 7.2379 8.34492 7.12013 8.43171 7.03324C8.5185 6.94646 8.63627 6.89768 8.75904 6.89768H15.8344C15.9605 6.90153 16.0816 6.94838 16.1775 7.03036C16.2734 7.11233 16.3385 7.22462 16.3621 7.34854L17.5099 12.4677V12.4678C17.5724 12.6972 17.5281 12.9427 17.3894 13.136C17.2506 13.3292 17.0322 13.4496 16.7947 13.4639L16.7947 13.4637Z",
    fill: "#D53C2E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.9254 13.4614H7.26851C7.52416 13.4614 7.73151 13.2058 7.73151 12.9984V7.36035C7.73151 7.1047 7.52426 6.89736 7.26851 6.89736H6.9254C6.66975 6.89736 6.4624 7.15301 6.4624 7.36035V12.9984C6.4624 13.2541 6.66965 13.4614 6.9254 13.4614V13.4614Z",
    fill: "#D53C2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDislike);
export default __webpack_public_path__ + "static/media/dislike.b006f9f9928cebcd97bb3ebbb0afdbeb.svg";
export { ForwardRef as ReactComponent };